export default "__VITE_ASSET__BK3FfGHi__"